"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var controller_drop_location_enum_1 = require("../../components/designer/form/controller-drop-location.enum");
var controller_model_1 = require("../../layout-models/form-models/controller.model");
var layout_utils_1 = require("../layout-utils");
var form_designer_constants_1 = require("../../components/designer/form/form-designer.constants");
var form_card_cell_model_1 = require("../../layout-models/form-models/form-card-cell.model");
var FormControllerElement = /** @class */ (function () {
    function FormControllerElement(domInfo) {
        this.domInfo = domInfo;
    }
    FormControllerElement.prototype.onClone = function (designerContext) {
        if (!this.controllerIsKBLeafNotInLayout()) {
            var draggingElement_1 = this.domInfo.getElem();
            var cloned_1 = false;
            var animationIndex_1 = 0;
            var offsetTop_1 = 0;
            var offsetLeft_1 = 0;
            var getCoordinates_1 = function (mouseEvent) {
                offsetLeft_1 = mouseEvent.clientX - draggingElement_1.offsetLeft;
                offsetTop_1 = mouseEvent.clientY - draggingElement_1.offsetTop;
            };
            var animate_1 = function () {
                animationIndex_1 += 1;
            };
            var element_1 = document.querySelectorAll('.form-designer__component.gu-mirror .form-designer__label')[0];
            draggingElement_1.onmousemove = function (mouseEvent) {
                if (designerContext.itemInTrash) {
                    draggingElement_1.classList.add('form-designer__component--trash');
                }
                else {
                    draggingElement_1.classList.remove('form-designer__component--trash');
                }
                if (!cloned_1) {
                    getCoordinates_1(mouseEvent);
                    cloned_1 = true;
                }
                if (animationIndex_1 <= 20) {
                    element_1.style.width = "calc(100% - " + (animationIndex_1 * 4).toString() + "px)";
                    element_1.style.height = (70 - (animationIndex_1)).toString() + 'px';
                    element_1.style.marginTop = (animationIndex_1 / 2).toString() + 'px';
                    if (offsetLeft_1 > 40) {
                        element_1.style.marginLeft = (animationIndex_1 * 2).toString() + 'px';
                        element_1.style.marginRight = (animationIndex_1 * 2).toString() + 'px';
                    }
                    animate_1();
                }
            };
        }
    };
    FormControllerElement.prototype.onDrag = function (designerContext) {
        designerContext.showTrashBin = true;
    };
    FormControllerElement.prototype.onDrop = function (designerContext) {
        if (this.controllerInScrollElement()) {
            designerContext.cancelDragging('fields-bag');
            this.returnDroppedElement(designerContext);
        }
        else if (this.newControllerDropped()) {
            if (this.droppedInNestedCard()) {
                this.newControllerDroppedInNestedCard(designerContext);
            }
            else {
                this.newControllerDroppedAction(designerContext);
            }
        }
        else if (this.controllerDeleted()) {
            var cardId = this.domInfo.getSourceCardId();
            var controllerRowId = this.domInfo.getSourceRowId();
            var controllerId = this.domInfo.getControllerId();
            this.getControllerAndDeleteItFromRow(cardId, controllerRowId, designerContext);
            if (designerContext.isControlSettingsActive &&
                designerContext.formControlSettingsComponent.controllerModel
                    .id === controllerId) {
                designerContext.formControlSettingsComponent.close();
            }
        }
        else if (this.controllerDeletedFromNestedCard()) {
            var cardId = this.domInfo.getSourceCardId();
            var controllerRowId = this.domInfo.getSourceRowId();
            var nestedCardId = this.domInfo.getSourceNestedCardId();
            var nestedCardRowId = this.domInfo.getSourceNestedRowId();
            var controllerId = this.domInfo.getControllerId();
            this.getControllerAndDeleteItFromNestedCard(cardId, controllerRowId, nestedCardId, nestedCardRowId, designerContext);
            if (designerContext.isControlSettingsActive &&
                designerContext.formControlSettingsComponent.controllerModel
                    .id === controllerId) {
                designerContext.formControlSettingsComponent.close();
            }
        }
        else if (this.droppedToOtherCard()) {
            var cardId = this.domInfo.getDestinationCardId();
            var sourceCardId = this.domInfo.getSourceCardId();
            if (sourceCardId !== cardId) {
                this.handleControllerDropToOtherCard(cardId, sourceCardId, designerContext);
            }
            else {
                this.handleControllerReOrderInCard(cardId, designerContext);
            }
        }
        else if (this.droppedToNestedCardFromCard()) {
            this.handleDroppingToNestedCardFromCard(designerContext);
        }
        else if (this.droppedToCardFromNestedCard()) {
            this.handleDroppingToCardFromNestedCard(designerContext);
        }
        else if (this.droppedToNestedCardFromNestedCard()) {
            this.handleDroppingToNestedCardFromNestedCard(designerContext);
        }
    };
    FormControllerElement.prototype.onHover = function (designerContext) {
        if (this.controllerInScrollTopElement()) {
            layout_utils_1.LayoutUtils.scrollUp(designerContext);
            return;
        }
        if (this.controllerInScrollBottomElement()) {
            layout_utils_1.LayoutUtils.scrollDown(designerContext);
            return;
        }
        designerContext.hoveredRowId = this.domInfo.getContainerAttribute(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_ID_ATTRIBUTE);
        var cardId = this.domInfo.getContainerAttribute(form_designer_constants_1.FormDesignerConstants.CARD_IDENTITY_ATTRIBUTE);
        designerContext.beforeHoveredRowId = this.getBeforeRowId(cardId, designerContext.hoveredRowId, designerContext);
        designerContext.afterHoveredRowId = this.getAfterRowId(cardId, designerContext.hoveredRowId, designerContext);
        if (this.domInfo.itemInUpperRow()) {
            designerContext.newControllerDragLocation =
                controller_drop_location_enum_1.ControllerDropLocation.UPPER_PART;
        }
        else if (this.domInfo.itemInLowerRow()) {
            designerContext.newControllerDragLocation =
                controller_drop_location_enum_1.ControllerDropLocation.LOWER_ROW;
        }
        else if (this.domInfo.itemInTrash()) {
            // to review
            this.domInfo.addClassToElem('form-designer__component--trash');
            designerContext.itemInTrash = true;
        }
        else {
            designerContext.newControllerDragLocation =
                controller_drop_location_enum_1.ControllerDropLocation.IN_ROW;
        }
        if (!this.domInfo.itemInTrash()) {
            this.domInfo.removeClassFromElem('form-designer__component--trash');
            designerContext.itemInTrash = false;
        }
    };
    FormControllerElement.prototype.handleDroppingToNestedCardFromNestedCard = function (designerContext) {
        var destinationNestedCardId = this.domInfo.getDestinationNestedCardId();
        var sourceNestedCardId = this.domInfo.getSourceNestedCardId();
        var sourceCardId = this.domInfo.getSourceCardId();
        var sourceRowId = this.domInfo.getSourceRowId();
        var nestedRowId = this.domInfo.getSourceNestedRowId();
        var destinationCardId = this.domInfo.getDestinationCardId();
        var destinationRowId = this.domInfo.getDestinationRowId();
        var droppedItem = this.getControllerAndDeleteItFromNestedCard(sourceCardId, sourceRowId, sourceNestedCardId, nestedRowId, designerContext);
        if (droppedItem) {
            var rowWhereControllerDropped = this.processControlDroppingInNestedCard(droppedItem, designerContext);
            designerContext.drawControllerInNestedCard(destinationCardId, destinationRowId, destinationNestedCardId, rowWhereControllerDropped, droppedItem);
        }
    };
    FormControllerElement.prototype.handleDroppingToNestedCardFromCard = function (designerContext) {
        var destinationCardId = this.domInfo.getDestinationCardId();
        var sourceCardId = this.domInfo.getSourceCardId();
        var sourceRowId = this.domInfo.getSourceRowId();
        var nestedCardId = this.domInfo.getDestinationNestedCardId();
        var destinationRowId = this.domInfo.getDestinationRowId();
        var droppedController = this.getControllerAndDeleteItFromRow(sourceCardId, sourceRowId, designerContext);
        if (droppedController) {
            var rowWhereControllerDropped = this.processControlDroppingInNestedCard(droppedController, designerContext);
            designerContext.drawControllerInNestedCard(destinationCardId, destinationRowId, nestedCardId, rowWhereControllerDropped, droppedController);
        }
    };
    FormControllerElement.prototype.processControlDroppingInNestedCard = function (droppedController, designerContext) {
        var nestedCardId = this.domInfo.getDestinationNestedCardId();
        var nestedRowId = this.domInfo.getDestinationNestedRowId();
        var destinationRowId = this.domInfo.getDestinationRowId();
        var nestedCardToDropIn = this.getNestedCard(this.domInfo.getDestinationCardId(), destinationRowId, nestedCardId, designerContext);
        var rowWhereControllerDropped;
        if (this.domInfo.itemInNestedRow()) {
            rowWhereControllerDropped = nestedCardToDropIn.insertInRow(form_card_cell_model_1.FormCardCellModel.cellWithController(droppedController), nestedRowId);
        }
        else if (this.domInfo.itemInNestedUpperRow()) {
            rowWhereControllerDropped = nestedCardToDropIn.insertInUpperRow(form_card_cell_model_1.FormCardCellModel.cellWithController(droppedController));
            designerContext.newCreatedRowId = rowWhereControllerDropped;
            var leaf = designerContext.nestedCardUpperRowModels.get(nestedCardId)[0];
            designerContext.nestedRowBagModels.set(rowWhereControllerDropped, [
                leaf,
            ]);
            designerContext.nestedLowerRowBagModels.set(rowWhereControllerDropped, []);
            designerContext.nestedCardUpperRowModels.set(nestedCardId, []);
        }
        else if (this.domInfo.itemInNestedLowerRow()) {
            rowWhereControllerDropped = nestedCardToDropIn.insertInLowerRow(form_card_cell_model_1.FormCardCellModel.cellWithController(droppedController), nestedRowId);
            designerContext.newCreatedRowId = rowWhereControllerDropped;
            var leaf = designerContext.nestedLowerRowBagModels.get(nestedRowId)[0];
            designerContext.nestedRowBagModels.set(rowWhereControllerDropped, [
                leaf,
            ]);
            designerContext.nestedLowerRowBagModels.set(rowWhereControllerDropped, []);
            designerContext.nestedCardUpperRowModels.set(nestedCardId, []);
        }
        if (droppedController.columnCount < nestedCardToDropIn.columnCount) {
            droppedController.columnCount =
                (12.0 / nestedCardToDropIn.columnCount) *
                    droppedController.columnCount;
            if (droppedController.columnCount > 12) {
                droppedController.columnCount = 12;
            }
        }
        else {
            droppedController.columnCount = 12;
        }
        return rowWhereControllerDropped;
    };
    FormControllerElement.prototype.handleDroppingToCardFromNestedCard = function (designerContext) {
        var nestedCardId = this.domInfo.getSourceNestedCardId();
        var nestedRowId = this.domInfo.getSourceNestedRowId();
        var sourceRowId = this.domInfo.getSourceRowId();
        var sourceCardId = this.domInfo.getSourceCardId();
        var destinationCardId = this.domInfo.getDestinationCardId();
        var droppedItem = this.getControllerAndDeleteItFromNestedCard(sourceCardId, sourceRowId, nestedCardId, nestedRowId, designerContext);
        if (droppedItem) {
            var rowWhereControlDropped = this.processControlDroppingInCard(droppedItem, designerContext);
            designerContext.drawController(rowWhereControlDropped, droppedItem, destinationCardId);
        }
        var nestedCard = this.getNestedCard(sourceCardId, sourceRowId, nestedCardId, designerContext);
        droppedItem.columnCount =
            droppedItem.columnCount * (nestedCard.columnCount / 12);
    };
    FormControllerElement.prototype.processControlDroppingInCard = function (droppedController, designerContext) {
        var destinationCardId = this.domInfo.getDestinationCardId();
        var destinationRowId = this.domInfo.getDestinationRowId();
        var rowWhereControlDropped;
        var formCardToDropIn = this.getCardForNewFieldController(destinationCardId, designerContext);
        if (this.domInfo.itemInRow()) {
            rowWhereControlDropped = formCardToDropIn.insertInRowOnIndex(form_card_cell_model_1.FormCardCellModel.cellWithController(droppedController), destinationRowId, this.getIndexInRow(destinationRowId, droppedController, designerContext));
        }
        if (this.domInfo.itemInUpperRow()) {
            rowWhereControlDropped = formCardToDropIn.insertInUpperRow(form_card_cell_model_1.FormCardCellModel.cellWithController(droppedController));
            designerContext.newCreatedRowId = rowWhereControlDropped;
            var leaf = designerContext.cardUpperRowModels.get(destinationCardId)[0];
            designerContext.rowBagModels.set(rowWhereControlDropped, [leaf]);
            designerContext.lowerRowBagModels.set(rowWhereControlDropped, []);
            designerContext.cardUpperRowModels.set(destinationCardId, []);
        }
        else if (this.domInfo.itemInLowerRow()) {
            rowWhereControlDropped = formCardToDropIn.insertInLowerRow(form_card_cell_model_1.FormCardCellModel.cellWithController(droppedController), destinationRowId);
            designerContext.newCreatedRowId = rowWhereControlDropped;
            var leaf = designerContext.lowerRowBagModels.get(destinationRowId)[0];
            designerContext.rowBagModels.set(rowWhereControlDropped, [leaf]);
            designerContext.lowerRowBagModels.set(destinationRowId, []);
            designerContext.lowerRowBagModels.set(rowWhereControlDropped, []);
        }
        return rowWhereControlDropped;
    };
    FormControllerElement.prototype.newControllerDroppedInNestedCard = function (designerContext) {
        var nestedCardId = this.domInfo.getDestinationNestedCardId();
        var cardId = this.domInfo.getDestinationCardId();
        var rowId = this.domInfo.getDestinationRowId();
        var nestedCardRowId = this.domInfo.getDestinationNestedRowId();
        var droppedItem = this.getDroppedControllerFromNestedCard(nestedCardId, nestedCardRowId, designerContext);
        var rowWhereControllerDropped;
        if (droppedItem) {
            droppedItem.checkedInLayout = true;
            var droppedController = new controller_model_1.ControllerModel(layout_utils_1.LayoutUtils.uniqueId(), droppedItem.meta, true);
            droppedItem.id = droppedController.id;
            if (droppedItem.field) {
                droppedController.addSingleField(droppedItem.field);
                droppedController.addSingleFieldMultilingualDisplayName(droppedItem.fieldMultilingualDisplayName);
                droppedController.state['maxLength'] =
                    droppedItem.field['maxLength'];
            }
            rowWhereControllerDropped = this.processControlDroppingInNestedCard(droppedController, designerContext);
            designerContext.drawControllerInNestedCard(cardId, rowId, nestedCardId, rowWhereControllerDropped, droppedController);
        }
    };
    FormControllerElement.prototype.getNestedCard = function (cardId, rowId, nestedCardId, designerContext) {
        var card;
        for (var _i = 0, _a = designerContext.layoutContent.layoutRows; _i < _a.length; _i++) {
            var row = _a[_i];
            card = row.cards.find(function (formCard) { return formCard.id === cardId; });
            if (card) {
                break;
            }
        }
        var cardRow = card.formCardRows.find(function (row) { return row.rowId === rowId; });
        var cardCell = cardRow.cells.find(function (cell) { return cell.id === nestedCardId; });
        return cardCell.card;
    };
    FormControllerElement.prototype.handleControllerReOrderInCard = function (cardId, designerContext) {
        var controllerDestinationRowId = this.domInfo.getDestinationRowId();
        var controllerSourceRowId = this.domInfo.getSourceRowId();
        var rowWhereControllerDropped;
        var reOrderedController = this.getControllerAndDeleteItFromRow(cardId, controllerSourceRowId, designerContext);
        if (reOrderedController) {
            rowWhereControllerDropped = this.processControlDroppingInCard(reOrderedController, designerContext);
            designerContext.drawController(rowWhereControllerDropped, reOrderedController, cardId);
            // if (controllerDestinationRowId !== controllerSourceRowId || !this.domInfo.itemInRow()) {
            //
            // }
        }
    };
    FormControllerElement.prototype.handleControllerDropToOtherCard = function (destinationCardId, sourceCardId, designerContext) {
        var controllerSourceRowId = this.domInfo.getSourceRowId();
        var rowWhereControllerDropped;
        var reOrderedController = this.getControllerAndDeleteItFromRow(sourceCardId, controllerSourceRowId, designerContext);
        if (reOrderedController) {
            rowWhereControllerDropped = this.processControlDroppingInCard(reOrderedController, designerContext);
            designerContext.drawController(rowWhereControllerDropped, reOrderedController, destinationCardId);
        }
    };
    FormControllerElement.prototype.returnDroppedElement = function (designerContext) {
        var rowId = this.domInfo.getSourceRowId();
        var controllerId = this.domInfo.getControllerId();
        designerContext.layoutContent.layoutRows.forEach(function (layoutRow) {
            layoutRow.cards.forEach(function (card) {
                var controllerRow = card.formCardRows.find(function (row) { return row.rowId === rowId; });
                if (controllerRow) {
                    var index = controllerRow.cells.findIndex(function (controller) { return controller.id === controllerId; });
                    designerContext.rowBagModels
                        .get(rowId)
                        .splice(index, 0, designerContext.scrollModels.pop());
                }
            });
        });
    };
    FormControllerElement.prototype.newControllerDroppedAction = function (designerContext) {
        var cardId = this.domInfo.getDestinationCardId();
        var rowId = this.domInfo.getDestinationRowId();
        var droppedItem = this.getDroppedController(cardId, rowId, designerContext);
        if (droppedItem) {
            var rowWhereCellDropped = void 0;
            var droppedController = new controller_model_1.ControllerModel(layout_utils_1.LayoutUtils.uniqueId(), droppedItem.meta, true);
            droppedItem.id = droppedController.id;
            if (droppedItem.field) {
                droppedController.addSingleField(droppedItem.field);
                droppedController.addSingleFieldMultilingualDisplayName(droppedItem.fieldMultilingualDisplayName);
                droppedController.state['maxLength'] =
                    droppedItem.field['maxLength'];
            }
            rowWhereCellDropped = this.processControlDroppingInCard(droppedController, designerContext);
            droppedItem.checkedInLayout = true;
            designerContext.drawController(rowWhereCellDropped, droppedController, cardId);
        }
    };
    FormControllerElement.prototype.getControllerAndDeleteItFromRow = function (cardId, rowId, designerContext) {
        var controllerId = this.domInfo.getControllerId();
        var desiredCard = this.getFormCardById(cardId, designerContext);
        var result;
        var desiredRow = desiredCard.formCardRows.find(function (item) { return item.rowId === rowId; });
        var rowIndex = desiredCard.formCardRows.findIndex(function (item) { return item.rowId === rowId; });
        if (desiredRow) {
            var controllerIndex = desiredRow.cells.findIndex(function (item) { return item.id === controllerId; });
            result = desiredRow.cells.find(function (item) { return item.id === controllerId; })
                .controller; // todo
            desiredRow.cells.splice(controllerIndex, 1);
            if (desiredRow.cells.length === 0) {
                desiredCard.formCardRows.splice(rowIndex, 1);
            }
        }
        return result;
    };
    FormControllerElement.prototype.getControllerAndDeleteItFromNestedCard = function (cardId, rowId, nestedCardId, nestedRowId, designerContext) {
        var controllerId = this.domInfo.getControllerId();
        var desiredCard = this.getFormCardById(cardId, designerContext);
        var result;
        // let controllerIndex: number;
        var desiredRow = desiredCard.formCardRows.find(function (item) { return item.rowId === rowId; });
        var desiredNestedCard = desiredRow.cells.find(function (item) { return item.id === nestedCardId; }).card;
        var desiredNestedRow = desiredNestedCard.formCardRows.find(function (item) { return item.rowId === nestedRowId; });
        var rowIndex = desiredNestedCard.formCardRows.findIndex(function (item) { return item.rowId === nestedRowId; });
        if (desiredRow) {
            var controllerIndex = desiredNestedRow.cells.findIndex(function (item) { return item.id === controllerId; });
            result = desiredNestedRow.cells.find(function (item) { return item.id === controllerId; }).controller; // todo
            desiredNestedRow.cells.splice(controllerIndex, 1);
            if (desiredNestedRow.cells.length === 0) {
                desiredNestedCard.formCardRows.splice(rowIndex, 1);
            }
        }
        return result;
    };
    FormControllerElement.prototype.getDroppedController = function (cardId, controllerRowId, designerContext) {
        var newItem;
        if (this.domInfo.itemInUpperRow() &&
            designerContext.cardUpperRowModels.get(cardId)) {
            newItem = designerContext.cardUpperRowModels
                .get(cardId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInRow() &&
            designerContext.rowBagModels.get(controllerRowId)) {
            newItem = designerContext.rowBagModels
                .get(controllerRowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInLowerRow() &&
            designerContext.lowerRowBagModels.get(controllerRowId)) {
            newItem = designerContext.lowerRowBagModels
                .get(controllerRowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        return newItem;
    };
    FormControllerElement.prototype.getIndexInRow = function (controllerRowId, droppedController, designerContext) {
        var indexInRow = 0;
        if (this.domInfo.itemInRow() &&
            designerContext.rowBagModels.get(controllerRowId)) {
            indexInRow = designerContext.rowBagModels
                .get(controllerRowId)
                .findIndex(function (item) { return !item.checkedInLayout; });
            if (indexInRow < 0) {
                indexInRow = designerContext.rowBagModels
                    .get(controllerRowId)
                    .findIndex(function (item) { return item.id === droppedController.id; });
            }
        }
        return indexInRow;
    };
    FormControllerElement.prototype.getDroppedControllerFromNestedCard = function (nestedCardId, controllerNestedRowId, designerContext) {
        var newItem;
        if (this.domInfo.itemInNestedUpperRow() &&
            designerContext.nestedCardUpperRowModels.get(nestedCardId)) {
            newItem = designerContext.nestedCardUpperRowModels
                .get(nestedCardId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInNestedRow() &&
            designerContext.nestedRowBagModels.get(controllerNestedRowId)) {
            newItem = designerContext.nestedRowBagModels
                .get(controllerNestedRowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInNestedLowerRow() &&
            designerContext.nestedLowerRowBagModels.get(controllerNestedRowId)) {
            newItem = designerContext.nestedLowerRowBagModels
                .get(controllerNestedRowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        return newItem;
    };
    FormControllerElement.prototype.getCardForNewFieldController = function (cardId, designerContext) {
        // will changed after first phase
        return designerContext.layoutCards.find(function (cardType) { return cardType.card.id === cardId; }).card;
    };
    FormControllerElement.prototype.controllerIsKBLeafNotInLayout = function () {
        return (this.domInfo.elemIdEquals(form_designer_constants_1.FormDesignerConstants.NEW_FIELD_CONTROLLER) ||
            this.domInfo.elemIdEquals(form_designer_constants_1.FormDesignerConstants.NEW_PLUGGED_CONTROLLER));
    };
    FormControllerElement.prototype.droppedToOtherCard = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            !this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN) &&
            !this.domInfo.isContainerNestedCard());
    };
    FormControllerElement.prototype.droppedToNestedCardFromCard = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            !this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN) &&
            this.domInfo.isContainerNestedCard());
    };
    FormControllerElement.prototype.droppedToCardFromNestedCard = function () {
        return (this.domInfo.isSourceNestedCard() &&
            (this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) ||
                this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.UPPER_ROW_CONTAINER) ||
                this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.LOWER_ROW_CONTAINER)) &&
            !this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN));
    };
    FormControllerElement.prototype.droppedToNestedCardFromNestedCard = function () {
        return (this.domInfo.isSourceNestedCard() &&
            this.domInfo.isContainerNestedCard() &&
            !this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN));
    };
    FormControllerElement.prototype.newControllerDropped = function () {
        return (!this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            !this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN) &&
            !this.domInfo.isSourceNestedCard());
    };
    FormControllerElement.prototype.droppedInNestedCard = function () {
        return (this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_UPPER_ROW_CONTAINER) ||
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER) ||
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_LOWER_ROW_CONTAINER));
    };
    FormControllerElement.prototype.controllerDeleted = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN));
    };
    FormControllerElement.prototype.controllerDeletedFromNestedCard = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.NESTED_CARDS_ROW_CONTAINER) &&
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN));
    };
    FormControllerElement.prototype.getBeforeRowId = function (cardId, rowId, designerContext) {
        var desiredCard = this.getFormCardById(cardId, designerContext);
        if (desiredCard) {
            var desiredRowIndex = desiredCard.formCardRows.findIndex(function (row) { return row.rowId === rowId; }) -
                1;
            if (desiredRowIndex >= 0) {
                return desiredCard.formCardRows[desiredRowIndex].rowId;
            }
        }
        return null;
    };
    FormControllerElement.prototype.getAfterRowId = function (cardId, rowId, designerContext) {
        var desiredCard = this.getFormCardById(cardId, designerContext);
        if (desiredCard) {
            var desiredRowIndex = desiredCard.formCardRows.findIndex(function (row) { return row.rowId === rowId; }) +
                1;
            if (desiredRowIndex < desiredCard.formCardRows.length) {
                return desiredCard.formCardRows[desiredRowIndex].rowId;
            }
        }
        return null;
    };
    FormControllerElement.prototype.getFormCardById = function (cardId, designerContext) {
        var designerContentLayout = designerContext.layoutContent;
        var desiredCard;
        designerContentLayout.layoutRows.map(function (layoutRow) {
            if (!desiredCard) {
                desiredCard = layoutRow.cards.find(function (card) { return card.id === cardId; });
            }
        });
        return desiredCard;
    };
    FormControllerElement.prototype.controllerInScrollTopElement = function () {
        return this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_SCROLLER_TOP_ELEMENT);
    };
    FormControllerElement.prototype.controllerInScrollBottomElement = function () {
        return this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_SCROLLER_BOTTOM_ELEMENT);
    };
    FormControllerElement.prototype.controllerInScrollElement = function () {
        return (this.controllerInScrollTopElement() ||
            this.controllerInScrollBottomElement());
    };
    return FormControllerElement;
}());
exports.FormControllerElement = FormControllerElement;
//# sourceMappingURL=form-controller.element.js.map